<template>
  <b-row
    v-if="!isOnboardingRedesign"
    class="onboarding-wrapper tw-justify-between tw-px-4"
    :style="{
      marginBottom: $_onboardingCtaFooter_marginBottom,
      paddingTop,
    }"
  >
    <b-col
      cols="12"
      lg="3"
      xl="4"
      xxl="4"
    >
      <!-- Don't remove this -->
      <slot name="header"></slot>
    </b-col>
    <b-col
      cols="12"
      lg="6"
      xl="4"
      xxl="4"
      class="onboarding-content mt-6"
    >
      <slot></slot>
    </b-col>
    <b-col
      cols="12"
      lg="3"
      xl="4"
      xxl="4"
    >
      <slot name="right"></slot>
      <!-- Don't remove this -->
    </b-col>
  </b-row>
  <div
    v-else
    class="onboarding-wrapper tw-justify-between tw-px-0 md:tw-px-12 lg:tw-px-0 xl:tw-mx-auto"
    :class="['treatment-options'].includes(page) ? 'xl:tw-max-w-[900px]' : 'xl:tw-max-w-[600px]'"
    :style="{
      marginBottom: $_onboardingCtaFooter_marginBottom,
      paddingTop,
    }"
  >
    <div class="onboarding-content tw-px-4 md:tw-px-0 lg:tw-px-20 xl:tw-px-0">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// mixins
import calculateBottom from '@/mixins/calculateBottom';
import resizeObserverMixin from '@/mixins/resizeObserverMixin';
import { onboardingCtaFooter } from '@/mixins/onboardingCtaFooter';

export default {
  name: 'OnboardingWrapper',
  mixins: [calculateBottom, resizeObserverMixin, onboardingCtaFooter],
  props: {
    elementId: {
      type: String,
      default: 'fixed-header',
    },
    targetRefName: {
      type: String,
      default: 'onboarding-progress-id',
    },
    page: {
      type: String,
      default: '',
    },
    hasVisibleBanner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    paddingTop() {
      if (this.hasVisibleBanner && this.windowWidth <= 768) {
        return '175px !important';
      }

      if (this.page === 'checkout' && !this.elementBottom) {
        return '175px !important';
      }
      return this.elementBottom + this.elementHeight + 'px !important';
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }

};
</script>
